import { StyleSheet } from 'react-native';
import {
  bold,
  defaultWidth,
  fontSizeSmall,
  fontSizeMedium,
  grey,
  darkGrey,
  fontFamilyLight,
  fontFamilyMedium,
} from '../../../constants/palette';

export default StyleSheet.create({
  artistName: {
    fontSize: fontSizeSmall,
    paddingBottom: 20,
    color: grey,
    width: defaultWidth,
  },
  container: {
    flexDirection: 'column',
    flex: 1,
  },
  contentContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 0,
  },

  imageContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    // borderWidth: 0.5,
    // borderRadius: 20,
    // borderColor: darkGrey,
    marginLeft: 5,
    marginRight: 5,
    marginTop: 0,
    marginBottom: 10,
  },
  image: {
    height: 225,
    width: 225,
    // height: 275,
    // width: defaultWidth,
    borderRadius: 20,
  },
  helpText: {
    marginBottom: 20,
    fontSize: fontSizeSmall,
    fontFamily: fontFamilyLight,
    width: defaultWidth,
  },
  helpContainer: {
    marginTop: 20,
  },
  loadingText: {
    fontSize: fontSizeMedium,
  },
  platformText: {
    marginBottom: 20,
    fontSize: fontSizeMedium,
    width: defaultWidth,
  },
  noMoreTracksToReview: {
    width: 275,
    marginBottom: 20,
  },
  trackName: {
    fontWeight: bold,
    fontSize: fontSizeMedium,
    fontFamily: fontFamilyMedium,
    width: defaultWidth,
  },
  trackInfoContainer: {
    justifyContent: 'flex-start',
  },
  trackFinishedText: {
    width: defaultWidth,
    marginBottom: 20,
    marginTop: 10,
  },

  title: {
    // fontSize: fontSizeMedium,
    fontWeight: bold,
  },
  welcomeBack: {
    marginBottom: 20,
    width: defaultWidth,
  },
  nonToneBirdsTracks: {
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
  },
  welcomeContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: 20,
  },
});
